import { useState } from "react";
import { ChevronDown, ChevronUp } from "react-feather";
import { Card, CardBody, CardHeader, Col, Collapse } from "reactstrap";
import { Btn, H5, H6 } from "../../../../../AbstractElements";
import { Href, UpcomingCoursesTitle } from "../../../../../Constants/Constants";
import { UpcomingCoursesData } from "../../../../../Data/Miscellaneous/Learning";

const UpcomingCourses = () => {
  const [isDevelopment, setIsDevelopment] = useState(true);

  return (
    <Col xl="12">
      <Card>
        <CardHeader>
          <H5 className="mb-0">
            <Btn color="transparent" className="btn-link d-flex align-items-center gap-2 justify-content-between" onClick={() => setIsDevelopment(!isDevelopment)}>
              {UpcomingCoursesTitle} {isDevelopment ? <ChevronDown /> : <ChevronUp />}
            </Btn>
          </H5>
        </CardHeader>
        <Collapse isOpen={isDevelopment}>
          <CardBody className="upcoming-course">
            {UpcomingCoursesData.map((data) => (
              <div className="d-flex" key={data.id}>
                <div className="flex-grow-1">
                  <H6 className="f-w-600">{data.title}</H6>
                  <span className="d-block">
                    {"Course By "} <a href={Href}> {data.anchorText}</a>
                  </span>
                  <span className="d-block">
                    {data.star.map((item) => (
                      <i key={item.id} className={`fa fa-${item.class} font-warning`}></i>
                    ))}
                  </span>
                </div>
                <div>
                  <H5 className="mb-0 font-primary">{data.value}</H5>
                  <span className="d-block">{data.month}</span>
                </div>
              </div>
            ))}
          </CardBody>
        </Collapse>
      </Card>
    </Col>
  );
};
export default UpcomingCourses;
